import { Box, Typography } from "@mui/material";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

export const GatterAppTitle = () => {
  const { isMobile } = useAppContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "row" : "column",
        alignItems: isMobile ? "flex-end" : "flex-start", // ✅ bottom align on mobile
        whiteSpace: "nowrap",
      }}
    >
      {/* ✅ Desktop only */}
      {!isMobile && (
        <Typography variant="h6" color="primary">
          KSB
        </Typography>
      )}

      {/* ✅ Main title */}
      <Typography
        color="primary"
        variant={isMobile ? "h6" : "h4"}
        fontWeight="bold"
      >
        Gatter App
      </Typography>

      {/* ✅ Subtitle */}
      <Typography
        color="primary"
        variant="caption"
        sx={{
          ml: isMobile ? 1 : 0,
          mb: isMobile ? "-1px" : 0, // ✅ visual alignment
        }}
      >
        von KSB IT
      </Typography>
    </Box>
  );
};
